"use client";

import { c as _c } from "react/compiler-runtime";
import { useSetTitle } from "@/contexts/TitleContext";
import useCapacitor from "@/hooks/useCapacitor";
import { AboutSection } from "@/types/enums";
import { useRouter } from "next/navigation";
import { useCookieConsent } from "../cookies/CookieConsentContext";

// Section components
import { capitalizeEveryWord } from "@/helpers/Helpers";
import { Col, Container, Row } from "react-bootstrap";
import AboutApply from "./AboutApply";
import AboutContactUs from "./AboutContactUs";
import AboutCookiePolicy from "./AboutCookiePolicy";
import AboutCopyright from "./AboutCopyright";
import AboutDataDecentral from "./AboutDataDecentral";
import AboutFAQ from "./AboutFAQ";
import AboutGDRC1 from "./AboutGDRC1";
import AboutGradients from "./AboutGradients";
import AboutHTML from "./AboutHTML";
import AboutLicense from "./AboutLicense";
import AboutMemeLab from "./AboutMemeLab";
import AboutMemes from "./AboutMemes";
import AboutMinting from "./AboutMinting";
import AboutNakamotoThreshold from "./AboutNakamotoThreshold";
import AboutNFTDelegation from "./AboutNFTDelegation";
import AboutPrimaryAddress from "./AboutPrimaryAddress";
import AboutPrivacyPolicy from "./AboutPrivacyPolicy";
import AboutReleaseNotes from "./AboutReleaseNotes";
import AboutSubscriptions from "./AboutSubscriptions";
import AboutTermsOfService from "./AboutTermsOfService";
export default function About(t0) {
  const $ = _c(22);
  const {
    section
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== section) {
    t1 = capitalizeEveryWord(section.replaceAll("-", " "));
    $[0] = section;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sectionTitle = t1;
  useSetTitle(`${sectionTitle} | About`);
  let t2;
  if ($[2] !== router) {
    t2 = newSection => {
      router.push(`/about/${newSection}`);
    };
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setNewSection = t2;
  let t3;
  if ($[4] !== section) {
    t3 = () => {
      switch (section) {
        case AboutSection.MEMES:
          {
            return <AboutMemes />;
          }
        case AboutSection.MEME_LAB:
          {
            return <AboutMemeLab />;
          }
        case AboutSection.GRADIENTS:
          {
            return <AboutGradients />;
          }
        case AboutSection.MINTING:
          {
            return <AboutMinting />;
          }
        case AboutSection.LICENSE:
          {
            return <AboutLicense />;
          }
        case AboutSection.APPLY:
          {
            return <AboutApply />;
          }
        case AboutSection.CONTACT_US:
          {
            return <AboutContactUs />;
          }
        case AboutSection.RELEASE_NOTES:
          {
            return <AboutReleaseNotes />;
          }
        case AboutSection.TERMS_OF_SERVICE:
          {
            return <AboutTermsOfService />;
          }
        case AboutSection.PRIVACY_POLICY:
          {
            return <AboutPrivacyPolicy />;
          }
        case AboutSection.COOKIE_POLICY:
          {
            return <AboutCookiePolicy />;
          }
        case AboutSection.DATA_DECENTR:
          {
            return <AboutDataDecentral />;
          }
        case AboutSection.GDRC1:
          {
            return <AboutGDRC1 />;
          }
        case AboutSection.NFT_DELEGATION:
          {
            return <AboutNFTDelegation />;
          }
        case AboutSection.SUBSCRIPTIONS:
          {
            return <AboutSubscriptions />;
          }
        case AboutSection.NAKAMOTO_THRESHOLD:
          {
            return <AboutNakamotoThreshold />;
          }
        case AboutSection.COPYRIGHT:
          {
            return <AboutCopyright />;
          }
        case AboutSection.PRIMARY_ADDRESS:
          {
            return <AboutPrimaryAddress />;
          }
        case AboutSection.FAQ:
          {
            return <AboutFAQ />;
          }
        case AboutSection.ENS:
          {
            return <AboutHTML path="ens" title="ENS" />;
          }
        case AboutSection.MISSION:
          {
            return null;
          }
        default:
          {
            return null;
          }
      }
    };
    $[4] = section;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const renderSection = t3;
  let t4;
  if ($[6] !== section || $[7] !== setNewSection) {
    t4 = <div className="tw-hidden tw-w-1/5 md:tw-block"><AboutMenu currentSection={section} setSection={setNewSection} /></div>;
    $[6] = section;
    $[7] = setNewSection;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== renderSection) {
    t5 = renderSection();
    $[9] = renderSection;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="tw-w-full md:tw-w-4/5">{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className="tw-flex tw-flex-col md:tw-flex-row">{t4}{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== section || $[17] !== setNewSection) {
    t8 = <div className="tw-mt-6 tw-block tw-text-center md:tw-hidden"><AboutMenu currentSection={section} setSection={setNewSection} /></div>;
    $[16] = section;
    $[17] = setNewSection;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <Container className="pt-2"><Row><Col>{t7}{t8}</Col></Row></Container>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function AboutMenu(t0) {
  const $ = _c(62);
  const {
    currentSection,
    setSection
  } = t0;
  const capacitor = useCapacitor();
  const {
    country
  } = useCookieConsent();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="tw-mb-2 tw-text-xl tw-font-semibold">About</h3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentSection || $[2] !== setSection) {
    t2 = <MenuItem section={AboutSection.MEMES} title="The Memes" setSection={setSection} currentSection={currentSection} />;
    $[1] = currentSection;
    $[2] = setSection;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== capacitor.isIos || $[5] !== country || $[6] !== currentSection || $[7] !== setSection) {
    t3 = (!capacitor.isIos || country === "US") && <MenuItem section={AboutSection.SUBSCRIPTIONS} title="Subscriptions" setSection={setSection} currentSection={currentSection} />;
    $[4] = capacitor.isIos;
    $[5] = country;
    $[6] = currentSection;
    $[7] = setSection;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  let t5;
  if ($[9] !== currentSection || $[10] !== setSection) {
    t4 = <MenuItem section={AboutSection.MEME_LAB} title="Meme Lab" setSection={setSection} currentSection={currentSection} />;
    t5 = <MenuItem section={AboutSection.GRADIENTS} title="Gradient" setSection={setSection} currentSection={currentSection} />;
    $[9] = currentSection;
    $[10] = setSection;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <hr className="tw-my-2" />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  let t8;
  let t9;
  if ($[14] !== currentSection || $[15] !== setSection) {
    t7 = <MenuItem section={AboutSection.GDRC1} title="GDRC1" setSection={setSection} currentSection={currentSection} />;
    t8 = <MenuItem section={AboutSection.NFT_DELEGATION} title="NFT Delegation" setSection={setSection} currentSection={currentSection} />;
    t9 = <MenuItem section={AboutSection.PRIMARY_ADDRESS} title="Primary Address" setSection={setSection} currentSection={currentSection} />;
    $[14] = currentSection;
    $[15] = setSection;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <hr className="tw-my-2" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[20] !== currentSection || $[21] !== setSection) {
    t11 = <MenuItem section={AboutSection.FAQ} title="FAQ" setSection={setSection} currentSection={currentSection} />;
    t12 = <MenuItem section={AboutSection.ENS} title="ENS" setSection={setSection} currentSection={currentSection} />;
    t13 = <MenuItem section={AboutSection.MINTING} title="Minting" setSection={setSection} currentSection={currentSection} />;
    t14 = <MenuItem section={AboutSection.NAKAMOTO_THRESHOLD} title="Nakamoto Threshold" setSection={setSection} currentSection={currentSection} />;
    t15 = <MenuItem section={AboutSection.LICENSE} title="License" setSection={setSection} currentSection={currentSection} />;
    $[20] = currentSection;
    $[21] = setSection;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t11 = $[22];
    t12 = $[23];
    t13 = $[24];
    t14 = $[25];
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <hr className="tw-my-2" />;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  let t18;
  let t19;
  let t20;
  if ($[28] !== currentSection || $[29] !== setSection) {
    t17 = <MenuItem section={AboutSection.APPLY} title="Apply" setSection={setSection} currentSection={currentSection} />;
    t18 = <MenuItem section={AboutSection.CONTACT_US} title="Contact Us" setSection={setSection} currentSection={currentSection} />;
    t19 = <MenuItem section={AboutSection.RELEASE_NOTES} title="Release Notes" setSection={setSection} currentSection={currentSection} />;
    t20 = <MenuItem section={AboutSection.DATA_DECENTR} title="Data Decentralization" setSection={setSection} currentSection={currentSection} />;
    $[28] = currentSection;
    $[29] = setSection;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t17 = $[30];
    t18 = $[31];
    t19 = $[32];
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <hr className="tw-my-2" />;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  let t23;
  let t24;
  let t25;
  if ($[35] !== currentSection || $[36] !== setSection) {
    t22 = <MenuItem section={AboutSection.TERMS_OF_SERVICE} title="Terms of Service" setSection={setSection} currentSection={currentSection} />;
    t23 = <MenuItem section={AboutSection.PRIVACY_POLICY} title="Privacy Policy" setSection={setSection} currentSection={currentSection} />;
    t24 = <MenuItem section={AboutSection.COPYRIGHT} title="Copyright" setSection={setSection} currentSection={currentSection} />;
    t25 = <MenuItem section={AboutSection.COOKIE_POLICY} title="Cookie Policy" setSection={setSection} currentSection={currentSection} />;
    $[35] = currentSection;
    $[36] = setSection;
    $[37] = t22;
    $[38] = t23;
    $[39] = t24;
    $[40] = t25;
  } else {
    t22 = $[37];
    t23 = $[38];
    t24 = $[39];
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t17 || $[47] !== t18 || $[48] !== t19 || $[49] !== t2 || $[50] !== t20 || $[51] !== t22 || $[52] !== t23 || $[53] !== t24 || $[54] !== t25 || $[55] !== t3 || $[56] !== t4 || $[57] !== t5 || $[58] !== t7 || $[59] !== t8 || $[60] !== t9) {
    t26 = <div>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}</div>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
    $[49] = t2;
    $[50] = t20;
    $[51] = t22;
    $[52] = t23;
    $[53] = t24;
    $[54] = t25;
    $[55] = t3;
    $[56] = t4;
    $[57] = t5;
    $[58] = t7;
    $[59] = t8;
    $[60] = t9;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  return t26;
}
function MenuItem(t0) {
  const $ = _c(9);
  const {
    title,
    section,
    setSection,
    currentSection
  } = t0;
  let t1;
  if ($[0] !== section || $[1] !== setSection) {
    t1 = () => setSection(section);
    $[0] = section;
    $[1] = setSection;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = currentSection === section ? "1px solid" : "none";
  let t3;
  if ($[3] !== t2) {
    t3 = {
      borderBottom: t2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3 || $[7] !== title) {
    t4 = <div className="tw-py-1"><button onClick={t1} className="btn-link tw-font-medium tw-no-underline hover:tw-text-gray-400" style={t3}>{title}</button></div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}